var map = {
	"./background.png": [
		69435,
		435
	],
	"./charity_promote.png": [
		64149,
		149
	],
	"./charity_register.png": [
		60290,
		290
	],
	"./charity_video.png": [
		49243,
		243
	],
	"./logo.jpg": [
		69218,
		218
	],
	"./logo.png": [
		74427,
		427
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42358;
module.exports = webpackAsyncContext;